import React from 'react';
import {ReactComponent as SettingsIcon} from '../../../../../../../assets/main/groups/main-top/settings.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setSettingPopupsAC} from "app/popups-reducer";
import {ROLE_HR} from "entities/constants/constants";



export const GroupSettings = () => {
    const isGroupSetting = useAppSelector((state) => state.popups.isGroupSetting);
    const roleType = useAppSelector((state) => state.role.roleType);

    const dispatch = useAppDispatch()
    const onClickHandler = () => {
        dispatch(setSettingPopupsAC(!isGroupSetting))
    }


    return (
        <span className="group-controls-btn p-icon pointer-elem control-btn" onClick={onClickHandler}>
        <span className="text">Настройки группы</span>
      <span className="icon">
        <SettingsIcon/>
      </span>
    </span>
    );
};